import { render } from "./layout-sidebar.vue?vue&type=template&id=6d75197e&scoped=true"
import script from "./layout-sidebar.vue?vue&type=script&lang=ts"
export * from "./layout-sidebar.vue?vue&type=script&lang=ts"

import "./layout-sidebar.vue?vue&type=style&index=0&id=6d75197e&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-6d75197e"

export default script